export enum EntityType {
  Contact = 1,
  Institution = 3
}
